const SPACING = {
  TINY: 1,
  SMALL: 2,
  MEDIUM: 4,
  LARGE: 8,
};
export { SPACING };
